import { useEffect, useState } from "react";
import CricketScoreCard from "./CricketScoreCard";
import MatchTvPlayer from "./MatchTvPlayer";
import { useGetCricketScoreLiveQuery } from "../services/sports/sportsApi";

const MatchHeader = ({ matchName, matchDate, oddsData, matchId }) => {
  const [showTv, setShowTv] = useState(false);
  const [showScoreboard, setShowScoreboard] = useState(true);

  const { data: liveScoreData } = useGetCricketScoreLiveQuery(
    { beventId: matchId },
    { skip: !matchId || !showScoreboard, pollingInterval: 2000 }
  );

  // Ball-by-ball feed (crickapi v1) — client (sky99) scorecard jaisa hi
  // enrichment, taaki admin me bhi last balls/commentary same dikhe.
  const _scoreBase = liveScoreData?.data ?? liveScoreData;
  const matchKey =
    _scoreBase?.matchKey || _scoreBase?.v1?.[0]?.mfkey || _scoreBase?.liveData?.matchKey || "";
  const [ballFeeds, setBallFeeds] = useState([]);
  useEffect(() => {
    if (!matchKey || !showScoreboard) return undefined;
    let cancelled = false;
    const load = () => {
      fetch("https://content.crickapi.com/commentary/v1/getBallFeeds", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ matchKey, lastDocId: null, filters: {} }),
      })
        .then((r) => (r.ok ? r.json() : []))
        .then((d) => { if (!cancelled && Array.isArray(d)) setBallFeeds(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 5000);
    return () => { cancelled = true; clearInterval(t); };
  }, [matchKey, showScoreboard]);
  // bet99-score (sky99 DO, keyed by gmid) — 1s poll, guru99admin jaisa; CricketScoreCard fresh ho to
  // isi ko primary leta hai (side names, score, "kaun bat kar raha hai"). Sab admin domains se CORS *.
  const [bet99Score, setBet99Score] = useState(null);
  useEffect(() => {
    if (!matchId || !showScoreboard) return undefined;
    let cancelled = false;
    const load = () => {
      fetch(`https://api.sky99.co/api/bet99-score/${encodeURIComponent(matchId)}`)
        .then((r) => (r.ok || r.status === 202 ? r.json() : null))
        .then((d) => { if (!cancelled && d) setBet99Score(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 1000);
    return () => { cancelled = true; clearInterval(t); };
  }, [matchId, showScoreboard]);
  const enrichedScoreData = _scoreBase
    ? {
        ..._scoreBase,
        v1: ballFeeds.length ? ballFeeds : (_scoreBase?.v1 || []),
        bet99Score: bet99Score ?? _scoreBase?.bet99Score ?? null,
      }
    : null;

  const displayName = matchName || "Loading...";

  return (
    <>
      <div className="bg-[#2c3e50] text-white px-3 py-2 flex items-center justify-between">
        {/* Left side - Match info */}
        <div>
          <div className="font-medium text-base">{displayName}</div>
          <div className="text-xs text-gray-300 mt-1">{matchDate}</div>
        </div>

        {/* Right side - Icons */}
        <div className="flex gap-3">
          {/* TV button */}
          <button
            onClick={() => setShowTv(v => !v)}
            className={`px-2 py-1 rounded flex items-center justify-center transition-colors ${
              showTv ? 'bg-teal-500 text-white' : 'bg-white text-black hover:bg-gray-200'
            }`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
              <polyline points="17 2 12 7 7 2"/>
            </svg>
          </button>

          {/* Scoreboard button */}
          <button
            onClick={() => setShowScoreboard(v => !v)}
            title={showScoreboard ? 'Hide scoreboard' : 'Show scoreboard'}
            className={`px-2 py-1 rounded flex items-center justify-center transition-colors ${
              showScoreboard ? 'bg-teal-500 text-white' : 'bg-white text-black hover:bg-gray-200'
            }`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Live TV — sky99 match-TV pipeline (purana diamond iframe "Access Denied" deta tha) */}
      {showTv && matchId && (
        <div className="bg-black">
          <MatchTvPlayer matchId={matchId} matchName={matchName} />
        </div>
      )}

      {/* Scoreboard */}
      {showScoreboard && matchId && (
        (liveScoreData?.score ?? liveScoreData?.data?.score) ? (
          <CricketScoreCard scoreData={enrichedScoreData} />
        ) : (
          <div className="bg-[#0c1524] border-t border-slate-700/40 text-slate-400 text-center text-xs py-3">
            Live score abhi available nahi hai (match live hone par yahan dikhega)
          </div>
        )
      )}
    </>
  );
};

export default MatchHeader;
